"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {},
        chipContainer: {
            display: 'flex',
            gap: 8,
            flexWrap: 'wrap',
        },
        fileChip: {
            cursor: 'pointer',
            flexBasis: 300,
            flexShrink: 1,
        },
        fileChipRoot: {
            height: 'unset',
            marginRight: theme.spacing(0.5),
            marginTop: theme.spacing(0.25),
            marginBottom: theme.spacing(0.25),
        },
        fileChiplabel: {
            textTransform: 'uppercase',
            color: theme.palette.primary.dark,
            fontWeight: 'bold',
            padding: "3px 8px",
            fontSize: 10
        },
        fileChipDeleteIcon: {
            color: theme.palette.primary.main,
            height: 18,
            '&:hover': {
                color: theme.palette.primary.light,
            }
        }
    });
});
